import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-locize-backend';
// import LastUsed from 'locize-lastused';
// import Editor from 'locize-editor';

const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN;
const LOCIZE_PROJECT_ID = process.env.REACT_APP_LOCIZE_PROJECT_ID;
const LOCIZE_API_KEY = process.env.REACT_APP_LOCIZE_API_KEY;

const locizeOptions = {
  projectId: LOCIZE_PROJECT_ID,
  apiKey: LOCIZE_API_KEY, // YOU should not expose your apps API key to production!!!
  referenceLng: 'pl',
};


// mapowanie subdomena -> kod języka i18n
const SUBDOMAIN_TO_LNG = {
  pl: 'pl',
  en: 'en',
  it: 'it',
  cz: 'cz', // ważne: cz -> cs (Czech)
  us: 'us',
};

// jeśli chcesz dopuścić też alias 'cs' w subdomenie:
const SUBDOMAIN_ALIASES = { cs: 'cs' };

const getBaseDomain = () => {
  // Np. "quiz.lifeswitcher.com" -> bazą jest "lifeswitcher.com"
  // Ale dla naszych potrzeb kluczowe jest to, co jest PRZED "quiz".
  // Zakładamy, że Twoja app zawsze siedzi pod *.quiz.lifeswitcher.com
  return BASE_DOMAIN;
};

const getLangFromSubdomain = () => {
  const { hostname } = window.location;
  // przykłady hostname:
  // quiz.lifeswitcher.com               -> domyślny pl
  // it.quiz-.lifeswitcher.com            -> it
  // cz.quiz.lifeswitcher.com            -> cs
  // en.quiz.lifeswitcher.com            -> en
  // dev: localhost:3000                 -> ignorujemy subdomeny

  if (hostname === 'localhost' || hostname.startsWith('localhost:')) return null;
console.log(getBaseDomain);
  const base = getBaseDomain(); // "quiz.lifeswitcher.com"
  if (!hostname.endsWith(base)) return null;
console.log(hostname.replace(`.${base}`, ''));
  const prefix = hostname.replace(`.${base}`, ''); // np. "it" albo całe hostname gdy nie ma kropki
  if (prefix === hostname) {
    // host = dokładnie "quiz.lifeswitcher.com" => brak prefixu => domyślnie pl
    return 'pl';
  }

  // jest prefix, np. "it", "en", "cz"
  const lower = prefix.toLowerCase();
  return SUBDOMAIN_TO_LNG[lower] || SUBDOMAIN_ALIASES[lower] || null;
};

const getInitialLanguage = () => {
  const fromSubdomain = getLangFromSubdomain();
  if (fromSubdomain) return fromSubdomain;

  const saved = localStorage.getItem('lang');
  if (saved) return saved;

  // jeśli chcesz brać pod uwagę przeglądarkę:
  const browser = (navigator.language || '').slice(0, 2);
  if (['pl', 'en', 'it', 'cs'].includes(browser)) return browser;

  return 'pl';
};

let initialLng = getInitialLanguage();
if (initialLng) localStorage.setItem('lang', initialLng);

if (initialLng === 'us') {
  initialLng = 'en';
}


// --------- LOCIZE ---------
i18n
  // i18next-locize-backend
  // loads translations from your project, saves new keys to it (saveMissing: true)
  // https://github.com/locize/i18next-locize-backend
  .use(Backend)
  // locize-lastused
  // sets a timestamp of last access on every translation segment on locize
  // -> safely remove the ones not being touched for weeks/months
  // https://github.com/locize/locize-lastused
  // .use(LastUsed)
  // locize-editor
  // InContext Editor of locize ?locize=true to show it
  // https://github.com/locize/locize-editor
  // .use(Editor)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  // .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: initialLng,
    fallbackLng: 'pl',
    debug: false,
    saveMissing: false,
    // defaultLanguage: 'pl',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: locizeOptions,
    locizeLastUsed: locizeOptions,
    editor: {
      ...locizeOptions,
      onEditorSaved: async (lng, ns) => {
        // reload that namespace in given language
        await i18n.reloadResources(lng, ns);
        // trigger an event on i18n which triggers a rerender
        // based on bindI18n below in react options
        i18n.emit('editorSaved');
      },
    },
    react: {
      bindI18n: 'languageChanged editorSaved',
      wait: true,
      // wait: false
    },
  });

export default i18n;
